import { AHText } from "arkh";
import { View } from "react-native";
import React from "react";
import { FormattedMessage } from "react-intl";
import { FollowupMissed } from "./FollowupMissed";

export function Symbols() {
  return (
    <View
      style={{
        justifyContent: "center",
        width: 140,
        marginLeft: 15,
        paddingBottom: 30,
      }}
    >
      <AHText>
        <FormattedMessage
          defaultMessage="Symbols"
          description="RoutineFollowUp: Symbols explanation title"
        />
      </AHText>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
          marginLeft: 5,
        }}
      >
        <FollowupMissed />
        <AHText style={{ marginLeft: 5 }} type="detail">
          <FormattedMessage
            defaultMessage="Missed Task"
            description="RoutineFollowUp: Missed Task text"
          />
        </AHText>
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
          marginLeft: 5,
        }}
      >
        <FollowupMissed isOptional />
        <AHText style={{ marginLeft: 5 }} type="detail">
          <FormattedMessage
            defaultMessage="Missed Optional Task"
            description="RoutineFollowUp: Missed Optional Task text"
          />
        </AHText>
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
          marginLeft: 5,
        }}
      >
        <FollowupMissed style={{ opacity: 0 }} isOptional />
        <AHText style={{ marginLeft: 5 }} type="detail">
          <FormattedMessage
            defaultMessage="Excluded Task"
            description="RoutineFollowUp: Excluded Task text"
          />
        </AHText>
      </View>
    </View>
  );
}
